// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tr9gX","label":"styles_label__1WzKL"};